import { useContext } from 'react'

import { storeContext } from 'state/context'

export const useStore = () => useContext(storeContext)
